<script lang="ts" setup>
import { ElMessage } from 'element-plus'
import { reactive } from 'vue'

import { useCharecterStore } from '@/stores/store'

const characterStore = useCharecterStore()

const form = reactive({
  username: '',
  password: '',
})

async function onSubmit() {
  console.log('submit!123')
  const res = await characterStore.login(form.username, form.password)
  if (res) {
    ElMessage.error(res.message)
  }
  else {
    ElMessage.success('登录成功')
  }
}
</script>

<template>
  <div>
    <h1>登录</h1>
    <el-form>
      <el-form-item label="用户名">
        <el-input v-model="form.username" />
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="form.password" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">
          登录
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
